import React, { useEffect, useRef, useState } from "react";
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "../Definitions/LayoutNode";
import { UserContext } from "../Definitions/UserContext";
import { ValidateToken } from "../Utilities/BusinessData";
import { AsyncAjaxGet, AsyncAjaxPost } from "../Utilities/AsyncAjaxService";
import { GetPopupCookieName, TrackingAccepted, setCookie } from "../Utilities/CookieUtils";
import { GetLinkFromLinkAttribute } from "./RenderButton";
import { GetLinkAndType, GetLinkValidation, LinkTypes } from "../Definitions/LinkData";
import DOMPurify from "dompurify";
import Loader from "../Common/Loader";
import { Dropdown } from "react-bootstrap";
import { componentAttributeTypes } from "../Definitions/AttributeTypes";
import { OpenDailyDealFromURL } from "../Utilities/OpenDailyDealFromURL";
import { ClosestWithClass, ClosestWithID } from "../Utilities/HTMLHelpers";



export default function RenderPopup({userContext,component,onDismiss,isPreview,onEnable}:{userContext:UserContext,component:AttributeCollection,onDismiss?:()=>void,isPreview?:boolean,onEnable?:()=>void}){


 

    const [hasSubmitted,setHasSubmitted] = useState(false);

    let isVertical  =  getNodeComponentAttributeValue(component,"pop-layout","")!="horizontal";

    let flexType = (isVertical)?"column":"row";
    
    const isForm = getNodeComponentAttributeValue(component,"pop-goal","")=="subscribe"

    let isEnabled = getNodeComponentAttributeValue(component,"popup-enabled","")=="enabled";

    let title = getNodeComponentAttributeValue(component,'pop-title',"Popup Title");
  
    let titleType = getNodeComponentAttributeValue(component,'pop-title-text',"h2");
    let titleColor = getNodeComponentAttributeValue(component,'pop-text-color',"");
    let descColor = getNodeComponentAttributeValue(component,'pop-desc-color',"");
    let descType = getNodeComponentAttributeValue(component,'pop-desc-text',"vp-2");
    let description =DOMPurify.sanitize( getNodeComponentAttributeValue(component,'pop-description',"Popup Description, this is where you'd have content that describes the goal of this popup")); 
    
    let disclaimer = DOMPurify.sanitize(getNodeComponentAttributeValue(component,"pop-disclaimer","By submitting this form, you consent to receive marketing communications from us. We value your privacy and won't share your email with third parties. You can unsubscribe at any time."));
    let primaryButtonTXT = getNodeComponentAttributeValue(component,"pop-main-btn-txt","Primary Action")
    let primaryButtonType = getNodeComponentAttributeValue(component,"pop-main-btn","primary")
    let rawPrimaryLink = getNodeComponentAttributeValue(component,"pop-main-btn-link","");

    let secondaryButtonTXT = getNodeComponentAttributeValue(component,"pop-sec-btn-txt","Secondary")
    let secondaryButtonType = getNodeComponentAttributeValue(component,"pop-second-btn","secondary")
    let rawSecondaryLink = getNodeComponentAttributeValue(component,"pop-sec-btn-link","");

    let imgURL = getNodeComponentAttributeValue(component,"pop-image","");
    let delay = getNodeComponentAttributeValue(component,"pop-timing");
 
    let emailOrPhone = getNodeComponentAttributeValue(component,"pop-up-email-or-phone","email");
    let showEmail = emailOrPhone.includes("email");
    let showPhone = emailOrPhone.includes("phone");
    let askGender = getNodeComponentAttributeValue(component,"pop-up-gender","")=="true";

    let useSecondary = (rawSecondaryLink!="none"&&rawSecondaryLink!="");

    if(useSecondary){
        let ld = GetLinkAndType(rawSecondaryLink);
        if(ld.type == LinkTypes.Page&&!ld.link){
            useSecondary = false;
        }
    }


    let mainBtnLinkClass = "";
    let secondBtnLinkClass = "";
    let completeBtnLinkClass = "";

 


    let realTitle = getNodeComponentAttributeValue(component,'pop-title',"");
    const cookieName = GetPopupCookieName()+ encodeURIComponent(realTitle.replace(/ /g, "").toLowerCase());
    let rawCompletionLink = getNodeComponentAttributeValue(component,"pop-completion-link","");

    const isEditor = (window as any).isEditor?true:false;
    const freq = getNodeComponentAttributeValue(component,"pop-frequency","1");

    let mainBg = getNodeComponentAttributeValue(component,"pop-bg-color","white");

    let dontShowAfterSub = getNodeComponentAttributeValue(component,"pop-show-after-sub","")=="true";
    const [isLoading,setLoading] = useState(false);

    if(isEditor){
        mainBtnLinkClass = GetLinkValidation(rawPrimaryLink,userContext.countryCode).valid?"":"missing-link";
        secondBtnLinkClass = GetLinkValidation(rawSecondaryLink,userContext.countryCode).valid?"":"missing-link";  
        completeBtnLinkClass = GetLinkValidation(rawCompletionLink,userContext.countryCode).valid?"":"missing-link";
    }

    const clickOutside = ()=>{
    
        if(isEditor ){
          
            onDismiss&&onDismiss();
        }

    }


    if(isEditor&&userContext.countryCode){
        setNodeComponentAttributeValue(component,"group-id",userContext.countryCode.toString());
    }

    let groupId = parseInt(getNodeComponentAttributeValue(component,"group-id","1"));

    const [isSown,setShown] = useState(isEditor);
    let parse = parseInt(freq);
    let cookieExpireTime = (!isNaN(parse))?parse:1;


    if(!onDismiss&&!isEditor){
        onDismiss = ()=>{
    

   
            setCookie(cookieName,"closed",cookieExpireTime);
    
            (document.body as HTMLElement).style.overflow = "";
            setShown(false);
        }
    }


    const clickFromRawLink = (rawlink:string)=>{

        if(isEditor){
            return;
        }

        if(rawlink==""||rawlink=="dismiss"){
           onDismiss&& onDismiss();
           return;
        }

        


        let pages = (window as any).sitepagedata??[];
        let lData =  GetLinkAndType(rawlink);


        if(lData.type == LinkTypes.DailyDeal){

            setLoading(true);
            let url = lData.link;
            let context = {...userContext};
            let location = getNodeComponentAttributeValue(component,componentAttributeTypes.multiLocation,"");
            if(location){
                context.businessId = location;
            }

            OpenDailyDealFromURL(url,context,()=>setLoading(false),()=>setLoading(false));
        }

        else{

            let url=  GetLinkFromLinkAttribute(rawlink,pages);
            let a= document.createElement("a");
            a.href = url;
            document.body.appendChild(a);

            if(lData.type == LinkTypes.Page||lData.type == LinkTypes.Phone||lData.type == LinkTypes.Email){
                a.target = "_self";
                
            }
            else{
                a.target = "_blank"
            }
        

            a.click();
        }
        onDismiss&&onDismiss();
        

    }

    const primaryClick = ()=>{
        clickFromRawLink(rawPrimaryLink);
    }

    const secondaryClick = ()=>{
        clickFromRawLink(rawSecondaryLink);
    }


    let alignClass = (isVertical?"text-align-center":"text-align-left");
    


    useEffect(()=>{


        if(!isEditor){

            let onlyCertain = getNodeComponentAttributeValue(component,"show-popup","")=="certain";
            
            if(onlyCertain){
                let pageList = getNodeComponentAttributeValue(component,"pop-pages-to-show-on","").split(",");
                let pages = (window as any).sitepagedata??[]; //get the pages from window object (originally stored by navigation bar)

                let path = window.location.pathname;
                let split = path.split("/");
                let url = split.pop();
                if(url == "preview"){
                    url = split.pop();
                }

                let vgurlDom = document.getElementById("vgurl") as HTMLInputElement
                let vgURL =vgurlDom.value;

                if(!url||url == vgURL||url==''){ // url is the same as their vgurl we are on the home page
                    url = getHomepageUrl();
                }

                let found = false;
                for(let i = 0;i<pages.length;i++){
                    if(pages[i].url == url){
                        if(pageList.includes(pages[i].pageId)){
                            found = true;
                        }
                        break;
                    }
                }
                if(!found){ // don't display if not on the right page
                    return;
                }
            }

            let timeout = getNodeComponentAttributeValue(component,"pop-timing","0");
            let timing = parseInt(timeout);

            const show = ()=>{
                setShown(true);
            
               (document.body as HTMLElement).style.overflow = "hidden";
            }

            if(!isNaN(timing)){
                setTimeout(()=>{
                    show();
                },timing*1000);
            }
            else{
              show();
            }
        }

 

   
        else{

            const testClick = (e:PointerEvent)=>{
              
                if(e.target && ((e.clientX<window.innerWidth-300 && e.clientY>50)||e.clientX<200)){
                   
                    if(
                        ClosestWithID(e.target as HTMLElement,"pop-up-fixed-container") == null&&
                        ClosestWithClass(e.target  as HTMLElement,"filerobot-image-editor-root") == null &&
                        ClosestWithClass(e.target  as HTMLElement,"modal-dialog") == null&&
                        ClosestWithID(e.target  as HTMLElement,"OpenDialog1") == null
                    )
                    if(window.innerWidth>100){
                    onDismiss&&onDismiss();
                    }
                }
            }
            document.addEventListener("pointerdown",testClick);
            return ()=>{
                document.removeEventListener("pointerdown",testClick);
            }
        }
        

    },[]);

    useEffect(()=>{
        if(!isEditor && isSown){
            let fName = document.getElementById("popup-first-name") as HTMLInputElement;
            if(fName)
                fName.focus();
        }

    },[isSown])

    if(!isSown){
        return null;
    }
    const submitForm = (userContext:UserContext,onComplete?:()=>void,onError?:()=>void)=>{
    
        if((window as any).isEditor){
            return;
        }
    
        let bodyObject:any = {};
    
        let linkData =GetLinkAndType(rawCompletionLink); 
        
        

        let fName = document.getElementById("popup-first-name") as HTMLInputElement;
        let lName = document.getElementById("popup-last-name") as HTMLInputElement;
        let email = document.getElementById("popup-email") as HTMLInputElement;
        let phone = document.getElementById("popup-phone") as HTMLInputElement;
        let gender = document.getElementById('popup-gender') as HTMLSelectElement;
        let countryCode = document.getElementById("pop-country-code") as HTMLInputElement;
    
        let SiteUrl = (window.location.origin)

        if(SiteUrl.includes("mysite.vagaro.com")||SiteUrl.includes("localhost")||SiteUrl.includes("mysite24.bookitall.com")){
            let vgurl = (document.getElementById("vgurl") as HTMLInputElement)?.value;
            SiteUrl+="/"+vgurl;
        }   


        if(!fName|| !lName ){
            return false;
        }
    

        bodyObject.FirstName = fName.value;
        bodyObject.LastName = lName.value;
        bodyObject.SiteURL = SiteUrl;
    
        if(email){
            bodyObject.Email = email.value;
        }
        if(phone&&countryCode ){
            
            let num = phone.value.replace(/\D/g, '');

            
            bodyObject.Phone = num;
            
            bodyObject.CountryId = countryCode.value;

            

        }
        if(gender){
            if(gender.value&&gender.value!="Prefer not to answer")
            bodyObject.Gender = gender.value;
        }
        
        if(linkData.type == LinkTypes.PromoCode){
            bodyObject.PromotionID = linkData.link;
        }
    
        UploadFormData(userContext,bodyObject,(data:any)=>{
    
            onComplete&&onComplete();
            
        },(error:any)=>{
            onError&&onError();
            console.log(error);
        });
    }

    const onCompleteForm = ()=>{
        setLoading(false);
      
        setHasSubmitted(true);
        //set longer expiration if don't show after submission is selected
        let exp = (dontShowAfterSub)?365:cookieExpireTime;

        setCookie(cookieName,"closed",exp);

        let lData = GetLinkAndType(rawCompletionLink);

        if(lData.type != LinkTypes.PromoCode){

             if(rawCompletionLink==""||rawCompletionLink=="dismiss"||lData.link===""){
                
                return;
             }
          
          clickFromRawLink(rawCompletionLink);
        }

    }

    return <div className="center-all" id="pop-up-fixed-container" style={{pointerEvents:(isEditor?"none":"all"),  position:(isPreview?"absolute":"fixed"),top:"0",left:"0",width:"100%",height:"100%",zIndex:80000}} 
            
        onClick={(e)=>{

            if(e.target&&(e.target as HTMLElement).id=="pop-up-fixed-container"){
                clickOutside();
            }

        }}
    >{isLoading&&<Loader/>}
        <style>{PopupStylingString(isVertical)}
        </style>
        <div className="pop-up-container relative vanimation-fade-in-up block-edit " 
        {...{"show-type":"any"}}
        {...{"data-frequency":"1week"}}
        {...{"data-delay":`${delay}s`}}
        style={{pointerEvents:"all",display:"flex",overflow:"hidden",flexDirection:flexType as any,background:mainBg,borderRadius:"8px",boxShadow:"rgba(0, 0, 0, 0.28) 0px 4px 60px 20px, 0 0 0 5000px #0000004a",opacity:"0",minWidth:"400px",maxWidth:"calc(100vw - 50px)",maxHeight:(isEditor?"calc(100vh - 100px)":"calc(100vh - 100px)"),minHeight:(isVertical?"245px":"440px")}}>

        {
        imgURL &&<div className="pop-up-img relative" style={{backgroundImage:"url("+imgURL+")",backgroundSize:"cover",backgroundPosition:"center",minHeight:(isVertical?"20vh":""),minWidth:(isVertical?"320px":"380px"),width:(isVertical?"100%":""),maxWidth:(isVertical?"100%":"30vw")}}></div>  
        }
            <div id="pop-up-content" className="pop-up-content w-full flex-column  justify-start gap-large" style={{margin:"auto",padding:"32px",width:"480px",height:"100%",overflow:"auto",maxHeight:(isEditor?"calc(100vh - 100px)":"calc(100vh - 100px)")}}>
                {!hasSubmitted?
                <>
                <RenderTitle classAdd={alignClass} color={titleColor} heading={titleType} text={title}/>
                <div className={alignClass+" "+descType} style={{color:descColor}} dangerouslySetInnerHTML={{__html:description}}></div>

             
               
                {isForm&&<RenderForm userContext={userContext} btnClass={primaryButtonType+" "+completeBtnLinkClass} countryCode={groupId} isVertical={isVertical} disclaimer={disclaimer} phone={showPhone} email={showEmail} gender={askGender}  onSubmit={()=>{ setLoading(true); submitForm(userContext,onCompleteForm,()=>{
                                window.alert("There was an error submitting the form, please reload and try again");
                                setLoading(false);
                })}} />}
          
                {!isForm&&
                <>
                    <div>&nbsp;</div>
                    <div className={"button-row gap-med w-full justify-center "+(isVertical?"flex-row":"flex-column")} style={{minWidth:"240px"}}>
                        {useSecondary &&<button className={secondBtnLinkClass+" v-button center-all "+secondaryButtonType+(!isVertical?" w-full ":"")}
                        onClick={secondaryClick}
                        >{secondaryButtonTXT}</button>}
                        {primaryButtonTXT &&<button
                        onClick={primaryClick}
                        className={mainBtnLinkClass+" v-button  center-all "+primaryButtonType+(!isVertical?" w-full ":"")}>{primaryButtonTXT}</button>}
                    </div>
                </>
                }
                </>
                :
                <>
                <RenderTitle classAdd={alignClass} color={titleColor} heading={titleType} text={"Thanks for Subscribing!"}/>
                <div className={alignClass+" "+descType} style={{color:descColor}}>{"Please go to your email and verify your subscription."}</div>
                </>
                }
            </div>

            <button id="close-popup-button" onClick={onDismiss} className="center-all invisible-button" style={{position:"absolute",top:"4px",padding:"0px",right:"4px", background:"#ffffff88",borderRadius:"100px",width:"24px",height:"24px",fontFamily:"open-sans",color:"#333"}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" height={"1em"}> <path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>
            </button>
            {!isEnabled&&<div className="center-all flex-column gap-large" style={{padding:"20px",position:"absolute",top:"0",left:"0",width:"100%",height:"100%",background:"#ffffffaa",color:"#333",fontFamily:"proxima-nova",fontSize:"24px",backdropFilter:"blur(5px)"}}>
               <div className="font-large font-bold">Pop-up is Disabled</div>
                <button className="w-button center-all w-button-primary w-full"
                style={{maxWidth:"340px"}}
                onClick={()=>{
                   
                   
                    let dom = document.querySelector(".wb-panel.right-panel.nice-scroll button");
                    if(dom){

                        (dom as any).click();
                    }
                }}

                >Enable</button>
                </div>

            }
        </div>
    </div>


    

}

const inputStyle = {padding:"8px",border:"1px solid #ccc",borderRadius:"4px",width:"100%"}


const isValidEmail = (email:string) => {
    const regex = /^[A-Za-z0-9_\+-]+(\.[A-Za-z0-9_\+-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.([A-Za-z]{2,10})$/;
    return (email && regex.test(email));

};

const isValidPhone = (phone:string) => {

    return (phone&&phone.length>3);
}


async function GetCountryPhoneOptions(userContext:UserContext,onComplete:(data:any)=>void,onError:(error:any)=>void){

    await ValidateToken(userContext);

    let url = VagaroAPIEnums.countryPhone;
    AsyncAjaxGet(
        url,
        userContext.accessToken,
        (data:any)=>{
            onComplete(data);
        },
        (error:any)=>{
            onError(error);
        },userContext.businessId
    );


}

type CountryPhoneInfo = {
    countryCode:string,

    countryID:number,

    countryName:string,

    cssClass:string,

    dialingCode:string,

    isBusinessUseOnly:boolean

}

function RenderForm({disclaimer,email,phone,gender,onSubmit,countryCode,btnClass,isVertical,userContext}:{userContext:UserContext,disclaimer:string,email?:boolean,phone?:boolean,gender?:boolean,onSubmit?:()=>void,countryCode:number,btnClass:string,isVertical:boolean}){
    
    const [emailValidationMessage,setEmailValidationMessage] = useState("");
    const [phoneValidationMessage,setPhoneValidationMessage] = useState("");
    const [fnValidation,setFnValidation] = useState("");
    const [lnValidation,setLnValidation] = useState("");

    const [countryPhoneOptions,setCountryPhoneOptions] = useState<CountryPhoneInfo[]>([])
    
    const [cntryCode,setCountryCode] = useState(countryCode);

    useEffect(()=>{

        GetCountryPhoneOptions(userContext,(data:any)=>{
        
            if(data?.data?.data)
            setCountryPhoneOptions(data.data.data);
        },(error:any)=>{
            window.alert("Oops! we had some trouble loading this form, please reload and try again");
        });
    },[]);

    const validate = (forceCheck?:boolean)=>{
        let emailDom = document.getElementById("popup-email") as HTMLInputElement;
        let phoneDom = document.getElementById("popup-phone") as HTMLInputElement;
        let fnDom = document.getElementById("popup-first-name") as HTMLInputElement;
        let lnDom = document.getElementById("popup-last-name") as HTMLInputElement;

        if(fnDom&&lnDom){
            if(forceCheck){
            fnDom.value = fnDom.value.trim();
            lnDom.value = lnDom.value.trim();
            }
            else{
                fnDom.value = fnDom.value.trimStart().replaceAll("  "," ");
                lnDom.value = lnDom.value.trimStart().replaceAll("  "," ");
            }
            fnDom.maxLength = 32;
            lnDom.maxLength = 32;
        }

        let failed  = false;
        if(emailDom){
            emailDom.value = emailDom.value.replaceAll(" ","");
            let val = emailDom.value;
            
            if(!isValidEmail(val)){
                failed = true;
                if(forceCheck){
                    if(val ==="")
                        setEmailValidationMessage("Please enter a valid email address");
                    else
                        setEmailValidationMessage("Please enter a valid email address");

                }
            }
            else{
                setEmailValidationMessage("");
            }

        }

        if(fnDom&&lnDom){
            if(!fnDom.value){
                failed = true;
                if(forceCheck)
                    setFnValidation("Required");
            }
            else{
                setFnValidation("");
            }

            if(!lnDom.value){
                failed = true;
                if(forceCheck)
                    setLnValidation("Required");
            }
            else{
                setLnValidation("");
            }
        }

        if(phoneDom){
            let val = phoneDom.value;

                        
            if(!isValidPhone(val)||(cntryCode<5 && GetPhoneNumberLength(cntryCode)!=val.length )){
                failed = true;
                if(forceCheck){
                    if(val ==="")
                        setPhoneValidationMessage("Please enter a valid phone number");
                    else
                        setPhoneValidationMessage("Please enter a valid phone number");
                }
            }
            else{
                setPhoneValidationMessage("");
            }



        }

        return !failed;
    }

    const trySubmit = ()=>{

        if((window as any).isEditor)
            return;

  


        if(validate(true))
        onSubmit&&onSubmit();
    }

    return <div className="text-align-left flex-column gap-large" >
     
        <div className="flex-row-to-column-475 gap-med">
            <PopUpFormItem inId="popup-first-name" label="First Name" onValidate={validate} validationString={fnValidation}/>
            <PopUpFormItem inId="popup-last-name" label="Last Name" onValidate = {validate} validationString={lnValidation}/>
        </div>
       {(email||gender)&&<div className="flex-row-to-column-475 gap-med">
           {email&& <PopUpFormItem onValidate={validate} inId="popup-email" label="Email" validationString={emailValidationMessage}/>}
            {gender&& <PopUpFormSelectItem  inId="popup-gender" label="Gender (Optional)" options={["Male","Female","Non-Binary"]}/>}
           
        </div>}
        
        {phone&&<><PhoneFormItem onValidate={validate} cntryOptions={countryPhoneOptions} cntry={cntryCode} inId="popup-phone" label="Phone" onChangeCntry={(num:number)=>{
         
            let dom = document.getElementById("popup-phone") as HTMLInputElement;
            if(dom){
                dom.value = GetFormattedPhoneNumber(dom.value,num);
            }
            setCountryCode(num);
            }} validationString={phoneValidationMessage}/>
            <input type="hidden" style={{display:"none"}} id="pop-country-code" value={cntryCode} defaultValue={cntryCode} />
            </>}
        
        <div className="pop-up-disclaimer vp-3  font-small" style={{opacity:".75",fontSize:"12px",textAlign:(isVertical?"center":"left")}} dangerouslySetInnerHTML={{__html:disclaimer}}></div>
        <button 
        onClick={trySubmit}
        className={"v-button  w-full center-all "+btnClass} style={{marginTop:"8px"}}>Submit</button>
    </div>

}

function PopUpFormItem({label,inId,validationString,onValidate}:{label:string,inId:string,validationString?:string,onValidate:Function}){
    return <div className="flex-column gap-small w-full">
        <label style={{fontWeight:"500"}}>{label+":"}</label>
        <input 
        onBlur={(e:any)=>{e.currentTarget.value = e.currentTarget.value.trim();}}
        onChange={()=>onValidate()}
        id={inId} style={inputStyle} type="text" placeholder={label}/>
        {validationString&&<div className="font-small" style={{color:"darkred",margin:"0"}}>{validationString}</div>

        }
    </div>
}

function PhoneFormItem({cntryOptions,cntry,label,inId,validationString,onChangeCntry,onValidate}:{cntryOptions:CountryPhoneInfo[],cntry:number,label:string,inId:string,validationString?:string,onChangeCntry?:(newid:number)=>void,onValidate?:Function}){

    let prefix = "";

    let cOption = cntryOptions.find((c)=>c.countryID==cntry);



    const [maxWidth,setMaxWidth] = useState(500);
    const [filter,setFilter] = useState("");

    const updateMaxWidth = ()=>{   

        let dom = document.getElementById("pop-up-content");
        if(dom){
            let width = dom.clientWidth - 48;
            setMaxWidth(width);
        }

    }

    useEffect(()=>{

    updateMaxWidth();
    
    },[]);



    if(cOption){
        prefix = "+"+cOption.dialingCode;
    }

    const maxWidthStyle = {maxWidth:maxWidth+"px"};
   
    return <div className="flex-column gap-small w-full">
        <label style={{fontWeight:"500"}}>{label+":"}</label>
        <div className="flex-row">

            <div className="cntryselector" style={{...inputStyle,fontSize:"12px",height:"42px",borderRadius:"4px 0px 0px 4px",width:"72px",borderRight:"none",padding:"0px",background:"white"}}>
            <Dropdown drop="up" onToggle={(e:any)=>{updateMaxWidth(); 
                if(e){
                setTimeout(()=>{
               
                let dom = document.getElementById("c-filter") as HTMLInputElement;
              
                if(dom){
                    dom.focus();
                }} ,10);
            }


            }} className="h-full w-full all-country-flag-react dropdown" >
        <Dropdown.Toggle variant=""  bsPrefix=" dropdown-toggle h-full w-full btn invisible-button flex-row center-all force-after-down " id="dropdown-basic">
    <div className="center-all h-full w-full flag-select"><GetFlagFromClass classAdd={cOption?.cssClass??""}/>
    </div>
        </Dropdown.Toggle>
     
            <Dropdown.Menu style={{maxHeight:"240px",overflow:"auto",...maxWidthStyle,overflowX:"hidden"}}>


            <div className="select-filter-input w-full" style={{background:"white",zIndex:4,marginTop:"-8px",top:"-8px",padding:"8px",position:"sticky",left:"0"}}>
                     <input id="c-filter" type="text" className="w-full"  placeholder="Search" style={{padding:"8px 8px 8px 32px",borderRadius:"3px",border: "1px solid #CDCDCD"}}
                  onInput={(e)=>{setFilter(e.currentTarget.value);}}
                  
                  ></input>
                  <div style={{position:"absolute",left:"4px",top:"5px"}}>
                    <SearchIcon/>
                  </div>
          </div> 
          <div  className="flex-row gap-med justify-between" style={{padding:"4px",maxHeight:"0px",visibility:"hidden",whiteSpace:"nowrap",...maxWidthStyle}}><div className="flex-row gap-med"><GetFlagFromClass classAdd={""}/>{"South Georgia & South Sandwich Islands"}</div><div>+500</div></div>{/* use longest name as buffer */}
            {
                cntryOptions.map((option:CountryPhoneInfo,index:number)=>{
                    
                let split = filter.split(" ");
                let show = true;
                for(let i = 0;i<split.length;i++){
                    if(!option.countryName.toLowerCase().includes(split[i])){
                        show = false;
                        break;
                    }
                }
                if(filter&&!show)
                    return null;
          
                   return (
                    <Dropdown.Item className="flex-row gap-med justify-between" style={{padding:"4px",...maxWidthStyle,overflow:"hidden"}}  key={option.countryID} active={cntry==option.countryID} onClick={() => { onChangeCntry&&onChangeCntry(option.countryID); }}><div className="flex-row gap-med"><GetFlagFromClass classAdd={option.cssClass}/>{option.countryName}</div><div>+{option.dialingCode}</div></Dropdown.Item>
                )})
            }
            </Dropdown.Menu>
        
    </Dropdown>
            </div>
            <div className="relative w-full">
            <input id={inId} style={{...inputStyle,borderRadius:"0px 4px 4px 0px",paddingLeft:((1.35+(prefix.length)*.6)+"em")}} type="text" placeholder={label}
           
            onChange={(e)=>{
                let val = e.target.value;
                val = GetFormattedPhoneNumber(val,cntry);
                e.target.value = val;
                
                onValidate&&onValidate();
            }}

            />
            <div className="code-prefix" style={{position:"absolute",top:"9px",left:"10px",color:"#444"}}>{prefix}</div>
            </div>
        </div>
        {validationString&&<div className="font-small" style={{color:"darkred",margin:"0"}}>{validationString}</div>

        }
    </div>
}

function PopUpFormSelectItem({label,options,inId}:{label:string,inId:string, options:string[]}){
    return <div className="flex-column gap-small w-full">
        <label style={{fontWeight:"500"}}>{label+":"}</label>
       <div className='popup-select-dropdown'> <select defaultValue="" id={inId} style={{...inputStyle,background:"white",color:"#333"}} >
            <option value="">{"Select Gender"}</option>
            {
                options.map((option:string)=>(
                    <option value={option}>{option}</option>
                ))
            }
        </select></div>
    </div>
}

function GetFlagFromClass({classAdd}:{classAdd:string}){

    return <div style={{width:"36px",height:"36px"}} className={"countrys-Code tele-flag "+classAdd}></div>
}

function PopupStylingString(isVertical:boolean){


    let str =  `

        .pop-up-container select{
            appearance:none !important;
            position:relative;
            cursor:pointer !important;
        }
        .pop-up-container .popup-select-dropdown{
            position:relative;

        }

        .pop-up-container .dropdown-menu{
            max-height:calc(64px + 24vh) !important;
        }

        .pop-up-content .countrys-Code.tele-flag{
            background-size: 24px auto !important;
            background-position: center !important;
        }

        .force-after-down::after{

            border-top: .3em solid !important;
            border-bottom: 0 !important;
        }


        .pop-up-container .popup-select-dropdown::after{
            content:"";
            position:absolute;
            top:45%;
            right:8px;
          
            border: 5px solid transparent;
            border-top-color: #333;
        }
        @media (max-width: 880px) and (min-height: 500px){
            .pop-up-container{
                flex-direction:column !important;

            }

            .pop-up-content{
                justify-content:flex-start;
                overflow:auto;
            }

            .pop-up-container .pop-up-img{
                max-height:25vh !important;
                height:200px !important;
                min-height:25vh !important;
                max-width:100% !important;
            
            }
        }
        @media (max-width: 500px) and (min-height: 500px){
            .pop-up-container{
               min-width:calc(100vw - 48px) !important;

            }

            .pop-up-img{
                min-width:100% !important;
            }
            .pop-up-content{
             
                max-width:calc(100vw - 48px) !important;
            }


        }

        @media (max-height:500px){
            .pop-up-container{
                flex-direction: row !important;
                min-height:calc(-100px + 100vh) !important;
            }

            .pop-up-img{
                max-width:20vw !important;
                min-width:20vw !important;
                max-height:calc(-100px + 100vh) !important;
            }
        }

    `

    if((window as any).isEditor){

        
        str+= str.replaceAll("@media","@container");
    
        str += `
            .pop-up-container input, .pop-up-container select{
                pointer-events:none !important;
            }

            .screen-mobile .pop-up-container{
                max-height: 680px !important;
                max-width: 350px !important;
                min-width: 350px !important;

            }

            .screen-mobile .pop-up-img{
                max-height: 180px !important;
                min-height: 180px !important;
            }

            .screen-mobile .pop-up-content{
                max-width:100% !important;
            }
            
            .canvas{
                overflow:hidden !important;
            }
        `
    }


    return str;

}

const VagaroAPIEnums = {

    popupFormSubmit: "subscription/save",
    countryPhone:"countrylist/countrylistdetails"

}

async function UploadFormData(userContext:UserContext,bodyObject:any, onComplete?:(data:any)=>void, onError?:(error:any)=>void){

    await ValidateToken(userContext);

    const url = "merchants/"+VagaroAPIEnums.popupFormSubmit;

    await AsyncAjaxPost(
        url,
        JSON.stringify(bodyObject),
        userContext.accessToken,
        (data:any)=>{
            onComplete && onComplete(data);
        },
        (error:any)=>{
            onError && onError(error);
        },userContext.businessId
    );
}

function RenderTitle({text,color,heading,classAdd}:{text:string,color:string,heading:string,classAdd:string}){

    const styling = {color:color}

    switch(heading){
        case "h1":
            return <h1 className={classAdd} style={styling}>{text}</h1>
        case "h2":
            return <h2 className={classAdd} style={styling}>{text}</h2>
        case "h3":
            return <h3 className={classAdd} style={styling}>{text}</h3>
        case "h4":
            return <h4 className={classAdd} style={styling}>{text}</h4>
        default:
            return <h2 className={classAdd} style={styling}>{text}</h2>

    }
}



const formats = [
    "", //undefined
    "(###) ###-####", // US (1)
    "### #### ####", //UK (2)
    "###-###-####", //CA (3)
    "(##) #### ####", //AU (4)
  ];
  
  
  
 function GetPhoneNumberLength(countryId:number){
  
      return (formats[countryId]??formats[1]).length;
  }
  
 function GetFormattedPhoneNumber(teleString:string,groupId:number){
      
  
      teleString = teleString.replace(/[^0-9]/g, '');

    if(groupId>4){
        return teleString;
    }

  
      let newString = "";
      let compareString = formats[groupId]??"";
  
      let tIndex = 0;
      for(let i = 0;i<compareString.length;i++){
              
              if(tIndex>=teleString.length){
                  break;
              }
  
              if(compareString[i] == "#"){
                  newString+=teleString[tIndex];
                  tIndex++;
              }
              else{
                  newString+=compareString[i];
              }
      }
      
  
      return newString;
  
  }


  const getHomepageUrl = ()=>{
    let pages = (window as any).sitepagedata??[];
    let url = "";
    for(let i = 0;i<pages.length;i++){
        if(pages[i].isLandingPage){
            url = pages[i].url;
            break;
        }
    }
    return url;

}



    function SearchIcon() {
        return <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#555" style={{ position: "absolute", left: "14px", top: "16px", pointerEvents: "none" }}><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>
    }
  